const STORAGE_PROBE_KEY = '__storage_probe__';

/**
 * Some in-app browser bridges (e.g. Facebook's) and private-browsing modes
 * throw on sessionStorage access instead of just missing a key, so error
 * context needs to distinguish "storage unavailable" from "key was lost".
 */
export const isSessionStorageAvailable = (): boolean => {
  try {
    sessionStorage.setItem(STORAGE_PROBE_KEY, '1');
    sessionStorage.removeItem(STORAGE_PROBE_KEY);
    return true;
  } catch {
    return false;
  }
};

/** Same access can throw where isSessionStorageAvailable does — treat a throw as "not present". */
export const getSessionStorageItemSafely = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const removeSessionStorageItemSafely = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // nothing to clean up if storage isn't accessible
  }
};

/** Returns whether the write actually succeeded, so callers can gate on it when the value is load-bearing. */
export const setSessionStorageItemSafely = (key: string, value: string): boolean => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};
